export default __webpack_public_path__ + "static/media/manage-employee.7e3c3ca5.png";